<div>
    <div class="flex flex-row">
        <div class="flex flex-col gap-2" style="flex: 1 1;">
            <div>
                <aeg-company-info :identifier="billingDetail.identifier" :name="billingDetail.companyName" />
            </div>
            <div>
                <address v-if="billingAddress" class="flex items-center gap-2">
                    <location-icon class="shrink-0"/><span>{{billingAddress}}</span>
                </address>
            </div>
            <div v-if="only1MailAddress" class="flex items-center gap-2">
                <mail-icon class="shrink-0"/><span>{{formatEmail(billingDetail.emails[0].email)}}</span>
            </div>
        </div>
        <div style="flex: 1 1; display: flex; flex-direction: column; gap: .5rem;" v-if="!only1MailAddress">
            <div v-for="email in billingDetail.emails" :key="email.service" class="flex items-center gap-2">
                <mail-icon class="shrink-0"/><span>{{email.service}}: {{formatEmail(email.email)}}</span>
            </div>
        </div>
    </div>
</div>
